import gql from "graphql-tag";

export const updateCatalogCategoryMutation = gql`
  mutation updateCatalogCategory(
    $id: ID!
    $name: String
    $isActive: Boolean
    $sort: Int
    $parentId: ID
    $forNotice: Boolean
    $productCategoryIds: [ID!]
  ) {
    updateCatalogCategory(
      id: $id
      name: $name
      isActive: $isActive
      sort: $sort
      parentId: $parentId
      forNotice: $forNotice
      productCategoryIds: $productCategoryIds
    ) {
      id
    }
  }
`;

export const deleteCatalogCategoryMutation = gql`
  mutation deleteCatalogCategory($id: ID!) {
    deleteCatalogCategory(id: $id) {
      id
    }
  }
`;
